class Draggable
{
  constructor()
  {
  }

  start(element)
  {
    this.element = element;
    this.original_parent_element = element.parentElement;

    this.container = document.createElement('div');
    this.container.classList.add('draggable-element');
    document.body.appendChild(this.container);

    this.drag_handle = this.element.querySelector('.draggable__handle');
    this.drag_handle.addEventListener('pointerdown', this._start_drag.bind(this));
    window.addEventListener('pointerup', this._stop_drag.bind(this));
    window.addEventListener('pointermove', this._on_pointer_move.bind(this));

    this.snap_back_button = this.element.querySelector('.draggable__snap-back');
    this.snap_back_button.addEventListener('click', this.snap_to_parent.bind(this));

    this.is_dragging = false;
    this.detached = false;
    this.drag_offset_x = 0;
    this.drag_offset_y = 0;
  }

  snap_to_parent()
  {
    this.original_parent_element.appendChild(this.element);
    this.snap_back_button.classList.add('hidden');
    this.container.classList.add('hidden');
    this.detached = false;
  }

  detach_from_parent()
  {
    const rect = this.element.getBoundingClientRect();
    this.container.style.left = rect.left + 'px';
    this.container.style.top = rect.top + 'px';

    this.container.appendChild(this.element);

    this.snap_back_button.classList.remove('hidden');
    this.container.classList.remove('hidden');
  }

  _start_drag(e)
  {
    e.preventDefault();
    if (!this.detached)
    {
      this.detach_from_parent();
      this.detached = true;
    }
    this.is_dragging = true;
    this.drag_offset_x = e.clientX - this.container.offsetLeft;
    this.drag_offset_y = e.clientY - this.container.offsetTop;

    console.log('start dragging', this.drag_offset_x, this.drag_offset_y);
  }

  _stop_drag(e)
  {
    this.is_dragging = false;
  }

  _on_pointer_move(e)
  {
    if (this.is_dragging)
    {
      let new_left = e.clientX - this.drag_offset_x;
      let new_top = e.clientY - this.drag_offset_y;

      // Get window bounds
      const max_left = window.innerWidth - this.container.offsetWidth;
      const max_top = window.innerHeight - this.container.offsetHeight;

      // Clamp values to keep window within bounds
      new_left = Math.max(0, Math.min(new_left, max_left));
      new_top = Math.max(0, Math.min(new_top, max_top));

      this.container.style.left = `${new_left}px`;
      this.container.style.top = `${new_top}px`;
      this.container.style.right = 'initial';
    }
  }
}

export { Draggable };
